import React from 'react';
import "./App.css";
import { useNavigate } from 'react-router-dom';

import logoECJ from "./img/ecj-logo.svg";

export default function PagoFailure() {
  const navigate = useNavigate();

  const btnBackToResume = () => {
    navigate('/');
  };

  return (
    <div className='thanks'>
      <img
        className='logoECJ'
        src={logoECJ}
        alt="EconoJournal"
      />
      <h2>No pudimos procesar el pago</h2>
      <h4>Tu pago no se realizó. Revisá los datos e intentá de nuevo o probá con otro medio.</h4>
      <button onClick={btnBackToResume}>Volver al inicio</button>
    </div>
  );
}
